import { injectIntl } from 'react-intl';
import LoyaltyMismatchModal from './LoyaltyMismatchModal';

export default injectIntl(LoyaltyMismatchModal);
